import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {editHtmlDocument, htmlDocument} from '../../../models/htmlDocument.model';
import {Entity} from '../../../models/entity.model';
import {PdfEntitiesService} from '../../../_services/api/pdf-entities.service';
import {Subject, Subscription} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PdfService} from '../../../_services/api/pdf.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {BASE_URL} from '../../../_services/constants';
import {ScrollPosition} from '../../../models/browseDocuments.model';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {saveAs} from 'file-saver';
import {AnoFileNamePipe} from '../../../_pipes/ano-file-name.pipe';
import {Location} from '@angular/common';
import {animate, style, transition, trigger} from '@angular/animations';
import {fadeInAnimation} from '../../../_animations/fadeIn';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  providers: [AnoFileNamePipe],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateY(-50%)'}),
        animate('300ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ]),
    ]),
    trigger('slideRight', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateX(50%)'}),
        animate('300ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ]),
    ]), fadeInAnimation
  ]
})
export class DocumentComponent implements OnInit, OnChanges {
  @Output() editableDocument: EventEmitter<editHtmlDocument> = new EventEmitter<editHtmlDocument>();
  @Input() document: htmlDocument;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  labels: string[];

  currentSelection: string;
  entities: Entity[] = [];
  htmlWithMarks: string;
  documentHeight = 500;
  entitieChange: boolean;

  documentScale: string;
  currentPage: ScrollPosition;

  linkPdf: string;

  private subject = new Subject();
  private getEntities: Subscription = this.subject
    .pipe(
      switchMap((data: htmlDocument) =>
        this.entitiesService.upload(data)
          .pipe(
            catchError((e): any => {
              return [];
            })
          )
      )
    )
    .subscribe(
      (res) => {
        this.snackBar.open('Changes have been saved.', 'close', {
          duration: 2000,
        });
      },
      error => {
        console.log('Fetch Observer Error:' + error);
      }
    );

  constructor(private entitiesService: PdfEntitiesService, private pdfService: PdfService, private snackBar: MatSnackBar,
              private cdt: ChangeDetectorRef, private dialog: MatDialog, private anonFileName: AnoFileNamePipe,
              private location: Location) {
  }

  ngOnInit(): void {
    this.setWindowHeight();
    this.entitieChange = false;
    this.documentScale = 'scale(1)';
    // this.labels = ['person', 'location', 'phone', 'e-mail'];
    this.linkPdf = BASE_URL + '/text/document_pdf?docId=' + this.document.id;
    this.currentPage = new ScrollPosition(1, false);
  }

  showSelectedText(event: any) {
    const selection = window.getSelection().toString();
    if (window.getSelection) {
      if (selection !== '') {
        const menu = document.getElementById('menuBtn');
        menu.style.display = '';
        menu.style.position = 'fixed';
        menu.style.left = event.clientX + 5 + 'px';
        menu.style.top = event.clientY + 5 + 'px';
        this.trigger.openMenu();
        this.currentSelection = selection;
      }
    }
  }

  makeMarkInHTML(): void {
    this.entitieChange = true;
    this.document.entities = this.entities;
    this.editableDocument.emit({document: this.document, unSavedChanges: this.entitieChange});
    this.pdfService.documentEntities(this.document.id, this.entities).subscribe(
      response => {
        this.htmlWithMarks = response.content;
      },
      error => {
        console.log(error);
      }
    );
  }

  onMenuClosed(): void {
    const menu = document.getElementById('menuBtn');
    if (menu) {
      menu.style.display = 'none';
    }
  }

  makeSelection(label: string) {
    if (this.currentSelection !== '' && this.currentSelection !== undefined) {
      label = label.replace('-', '');
      this.entities.push(new Entity(this.currentSelection, label));
      this.makeMarkInHTML();
      // this.cdt.detectChanges();
      this.cdt.markForCheck();
    }
  }

  deleteEntity(entity: Entity): void {
    const index = this.entities.findIndex(x => x.label === entity.label && x.entityType === entity.entityType);
    if (index > -1) {
      this.entities.splice(index, 1);
      this.makeMarkInHTML();
      this.cdt.detectChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.document !== undefined) {
      this.htmlWithMarks = this.document.content;
      this.entities = [];
      this.document.entities.forEach( (entity) => {
        this.entities.push(new Entity(entity.label, entity.entityType));
      });
      this.cdt.detectChanges();
      this.htmlWithMarks = this.document.content;
    }
  }

  changeScale(scaleVal: number) {
    this.documentScale = 'scale(' + scaleVal + ')';
  }

  setWindowHeight() {
    const n = window.innerHeight - 140;
    this.documentHeight = (n < 500) ? 500 : n;
  }

  updateEntities() {
    const updateDoc = new htmlDocument(this.document.id, '', '', this.entities, this.document.numberOfPages);
    this.subject.next(updateDoc);
    this.entitieChange = false;
    this.editableDocument.emit({document: updateDoc, unSavedChanges: this.entitieChange});
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setWindowHeight();
  }

  goUp(): void {
    if (this.currentPage.page > 1) {
      this.currentPage = {...this.currentPage, page: Number(this.currentPage.page) - 1, fromButton: true};
      this.cdt.detectChanges();
    }
  }

  goDown(): void {
    if (this.currentPage.page < this.document.numberOfPages) {
      this.currentPage = {...this.currentPage, page: Number(this.currentPage.page) + 1, fromButton: true};
      this.cdt.detectChanges();
    }
  }

  getDocumentFromServer(): void {
    const filename = this.anonFileName.transform(this.document.name);
    this.pdfService.download(this.document.id).subscribe(response => {
        const blob = new Blob([response], {
          type: 'application/pdf'
        });
        saveAs(blob, filename);
      }, error => {
        this.snackBar.open('An unknown error has occurred.', 'close', {
          duration: 2000,
        });
      },
      () => {
        console.log('File downloaded successfully');
      });
  }

  goBack() {
    this.location.back();
  }

  downloadDocument(): void {
    if (!this.entitieChange) {
      this.getDocumentFromServer();
    } else {
      const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Unsaved changes',
          message: 'Do you want to download the file without saving your changes?',
          confirm: 'Save and download',
          dismiss: 'Download'
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {
          const updateDoc = new htmlDocument(this.document.id, '', '', this.entities, this.document.numberOfPages);
          this.entitieChange = false;
          this.editableDocument.emit({document: updateDoc, unSavedChanges: this.entitieChange});
          const filename = this.anonFileName.transform(this.document.name);
          this.entitiesService.saveAndDownload(updateDoc).subscribe(response => {
              const blob = new Blob([response], {
                type: 'application/pdf'
              });
              saveAs(blob, filename);
            }, error => {
              this.snackBar.open('An unknown error has occurred.', 'close', {
                duration: 2000,
              });
            },
            () => {
              console.log('File downloaded successfully');
            });

        }
        if (result === false) {
          this.getDocumentFromServer();
        }
      });
    }
  }
}
